import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";
import queryString from 'querystring';

let redux = reduxCreator.type('LIKES').plugin(axiosPlugin, {template: "array"});

let fetchLikeAction = redux.fetchActionGet();

redux.reducerForType('ADD', (state,payload) => {
    let newState = {...state};
    newState.data.unshift(payload.data);
    newState.total++;
    return newState;
});

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState.data = newState.data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState.total--;
        if(newState.total < 0){
            newState.total = 0;
        }
    }
    return newState;
});

export const TYPES = redux.types;

export const fetchLikes = (type, parentId, query = {}, more = false) => fetchLikeAction(`/${type}/${parentId}/likes?${queryString.stringify(query)}`,null , {more});
export const resetLikes = () => redux.actions.reset();

export const likes = redux.reducer();